import styled from 'styled-components'

import { TextParagraph } from '@atoms'
import { Colors } from '@utils/Colors'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 0 24px;
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`

export const Title = styled(TextParagraph).attrs({
  variant: 'headline-h1',
})`
  text-align: center;
  font-weight: 600;
  margin-bottom: 8px;
`

export const Subtitle = styled(TextParagraph).attrs({
  variant: 'body-3',
})`
  text-align: center;
  color: ${Colors.GRAY500};
`
